import styled from 'styled-components';

export const BodyContainer = styled.div`
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
